// ---------------------------------------------------------------------------
// Pedido de exemplo do preview.
//
// Não sai de banco: é fixo de propósito, para que o preview da Central seja
// igual para todo mundo e para que a comparação com o printer.service seja
// reprodutível. Nomes e valores no formato da Rede Lucco.
// ---------------------------------------------------------------------------

import { PedidoParaImpressao } from "./tipos";

/** Pedido de mesa — o caso mais completo da via de produção. */
export function pedidoExemploMesa(): PedidoParaImpressao {
  return {
    filial: "Famiglia Lucco",
    codigoPedido: "1042",
    tituloDocumento: "VIA DE PRODUÇÃO",
    data: "27/07/2026 - 20:35",
    periodo: "Jantar",
    caixa: "Caixa 01",
    operador: "Guilherme",
    tipoItem: 4,
    nomeItem: "Mesa 12",
    numeroPessoas: "4",
    lugar: "2",
    produtos: [
      {
        productName: "Pizza Margherita Grande",
        peopleNumber: "1",
        productCode: "101",
        productPrice: 89.9,
        productObservations: [
          { observationName: "sem cebola" },
          { observationName: "borda catupiry", observationPrice: 12 },
        ],
      },
      {
        productName: "Filé à Parmegiana",
        peopleNumber: "2",
        productCode: "204",
        productPrice: 76.5,
        productObservations: [{ observationName: "ao ponto" }],
        componentesCombo: ["Arroz branco", "Batata frita"],
      },
      {
        productName: "Água com gás 500ml",
        peopleNumber: "3",
        productCode: "902",
        productPrice: 8,
      },
      {
        productName: "Petit Gateau com sorvete de creme",
        peopleNumber: "4",
        productCode: "701",
        productPrice: 34.9,
        productDiscount: 5,
      },
    ],
    totais: {
      totalProdutos: "209,30",
      descontoConta: "0,00",
      descontoProdutos: "5,00",
      subtotal: "204,30",
      taxaServico: "20,43",
      taxaEntrada: "0,00",
      consumoMinimo: "0,00",
      taxaEstacionamento: "0,00",
      taxaEntrega: "0,00",
      total: "224,73",
      pagamentos: [
        { nome: "Cartão de Crédito", valor: "200,00" },
        { nome: "Dinheiro", valor: "30,00" },
      ],
      troco: "5,27",
    },
    outrasImpressoes: ["Bar", "Sobremesas"],
    permanencia: "1h 42m 10s",
    totalPorPessoa: "56,18",
  };
}

/** Pedido de delivery — exercita o ramo sem mesa. */
export function pedidoExemploDelivery(): PedidoParaImpressao {
  return {
    filial: "Famiglia Lucco",
    codigoPedido: "1043",
    tituloDocumento: "VIA DE PRODUÇÃO",
    data: "27/07/2026 - 20:51",
    periodo: "Jantar",
    caixa: "Caixa 01",
    operador: "Guilherme",
    entregador: "Claudio",
    tipoItem: 0,
    clienteNome: "Maria Aparecida de Souza",
    clienteTelefone: "(11) 98877-6655",
    clienteEndereco: "Rua das Acácias, 1234 - Jardim Paulista",
    clienteComplemento: "Apto 74, bloco B",
    clienteObservacao: "Interfone quebrado, ligar ao chegar",
    produtos: [
      {
        productName: "Pizza Calabresa Grande",
        productCode: "108",
        productPrice: 84.9,
        productObservations: [{ observationName: "sem azeitona" }],
      },
      {
        productName: "Refrigerante 2L",
        productCode: "905",
        productPrice: 15,
      },
    ],
    totais: {
      totalProdutos: "99,90",
      descontoConta: "0,00",
      descontoProdutos: "0,00",
      subtotal: "99,90",
      taxaServico: "0,00",
      taxaEntrada: "0,00",
      consumoMinimo: "0,00",
      taxaEstacionamento: "0,00",
      taxaEntrega: "8,00",
      total: "107,90",
      pagamentos: [{ nome: "Pix", valor: "107,90" }],
      troco: "0,00",
    },
    outrasImpressoes: [],
  };
}
